import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import ImmunizationBox from './ImmunizationBox'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import DetailedImmunization from './DetailedImmunization'
import ModalWindow from '@kenetto/uikit-modal'

import {currentSelectionActions} from '../../../../../../redux/currentSelection'
import Immunization from '../../../../../../models/Immunization/Immunization'
import withPolyglot from '../../../../../common/withPolyglot'

class ImmunizationBoxContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      modalIsOpen: props.selectedImmunization === props.immunization.id
    }
  }

  toggleModal () {
    if (this.state.modalIsOpen) {
      this.props.removeSelectedImmunization()
    } else {
      this.props.selectImmunization(this.props.immunization.id)
    }
    this.setState({
      modalIsOpen: !this.state.modalIsOpen
    })
  }

  handleClick () {
    this.toggleModal()
  }

  render () {
    const { immunization, adverseReactions, translate, clickDisabled } = this.props
    const adverseReaction = adverseReactions.find(reaction => reaction.id === immunization.adverseReactionId)
    const title = immunization.type !== 'immunoglobulin'
      ? translate('immunization', true, 'immunizationBox')
      : translate('immunoglobulin', true, 'immunizationBox')
    return <Fragment>
      <ModalWindow
        width='small'
        title={title}
        modalIsOpen={this.state.modalIsOpen}
        toggleModal={this.toggleModal.bind(this)}>
        <DetailedImmunization adverseReaction={adverseReaction} immunization={immunization} />
      </ModalWindow>
      <ImmunizationBox
        clickDisabled={clickDisabled}
        hasAdverseReaction={!!immunization.adverseReactionId}
        type={immunization.type || 'vaccine'}
        immunization={immunization}
        // handleClick={() => this.props.selectImmunization(immunization)}
        handleClick={this.handleClick.bind(this)}
        key={immunization.id}
        status={immunization.type === 'immunoglobulin' ? 'attention' : 'ok'} />
    </Fragment>
  }
}

ImmunizationBoxContainer.propTypes = {
  clickDisabled: PropTypes.bool,
  immunization: PropTypes.instanceOf(Immunization).isRequired,
  selectImmunization: PropTypes.func.isRequired,
  removeSelectedImmunization: PropTypes.func.isRequired
}

ImmunizationBoxContainer.defaultProps = {
  clickDisabled: false
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators(currentSelectionActions, dispatch)
}

function mapStateToProps ({adverseReactions, currentSelection}) {
  return {
    selectedImmunization: currentSelection.immunization,
    adverseReactions: adverseReactions
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withPolyglot(ImmunizationBoxContainer, 'immunizationBox'))
